import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"


// Book the appointment for the customer
export const postCreateCustomer = async (body) => {

    try {

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()

        const formBody = {
            salutation: body?.salutation,
            firstName: body?.firstName,
            lastName: body?.lastName,
            personMobilePhone: body?.personMobilePhone,
            personEmail: body?.personEmail,
            Diabetes__pc: body?.Diabetes__pc === "Yes" ? true : false,
            First_Appointment__c: body?.First_Appointment__c,
            Dont_Confirm__c: false,
            Communication_Preferences__c: "Email;",
            Marketing_Opt_In__c: body?.Marketing_Opt_In__c
        }

        const headers = {
            Authorization: `Bearer ${token}`
        }

        const res = await axios.post(`${BRIDGE_URL("services/apexrest/customer/")}`, formBody, { headers })
        return res.data

    } catch (err) {
        console.log(err)
    }

}